<template>

  <input
    ref="input"
    type="checkbox"
    :id="name"
    :name="name"
    v-model="value"
  >

</template>

<script>
  export default {
    name: 'FormControlCheckbox',

    props: {
      name: {
        type: String,
        required: true,
      },
    },

    data() {
      return {
        value: null,
      };
    },

    computed: {
      filled() {
        return this.value === null
          ? false
          : this.value;
      },
    },

    watch: {
      filled(value) {
        this.$emit('filled', value);
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/FormControlCheckbox.vue